import React, { useState } from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import Products from './components/Products'
import About from './components/About'
import Contact from './components/Contact'
import Footer from './components/Footer'
import Cart from './components/Cart'
import { CartProvider } from './context/CartContext'

function App() {
 const [isCartOpen, setIsCartOpen] = useState(false)

 return (
 <CartProvider>
 <div className="App">
 <Header onCartClick={() => setIsCartOpen(true)} />
 <main>
 <Hero />
 <Products />
 <About />
 <Contact />
 </main>
 <Footer />
 <Cart isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
 </div>
 </CartProvider>
 )
}

export default App
